import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ButtonRouter from './ButtonRouter';
import ClientProvider from './client';
export default createDemo(import.meta.url, ButtonRouter, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/integrations/routing/demos/button-router/ButtonRouter.tsx",
    "fileName": "ButtonRouter.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { Link as RouterLink, MemoryRouter, StaticRouter } from 'react-router';\nimport type { LinkProps as RouterLinkProps } from 'react-router';\nimport Button from '@mui/material/Button';\n\nconst LinkBehavior = React.forwardRef<any, Omit<RouterLinkProps, 'to'>>(\n  (props, ref) => <RouterLink ref={ref} to=\"/\" {...props} role={undefined} />,\n);\n\nfunction Router(props: { children?: React.ReactNode }) {\n  const { children } = props;\n  if (typeof window === 'undefined') {\n    return <StaticRouter location=\"/\">{children}</StaticRouter>;\n  }\n\n  return <MemoryRouter>{children}</MemoryRouter>;\n}\n\nexport default function ButtonRouter() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Router>\n        <Button component={RouterLink} to=\"/\">\n          With prop forwarding\n        </Button>\n        <br />\n        <Button component={LinkBehavior}>With inlining</Button>\n      </Router>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 31,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { Link as RouterLink, MemoryRouter, StaticRouter } from 'react-router';\nimport type { LinkProps as RouterLinkProps } from 'react-router';\nimport Button from '@mui/material/Button';\n\nconst LinkBehavior = React.forwardRef<any, Omit<RouterLinkProps, 'to'>>(\n  (props, ref) => <RouterLink ref={ref} to=\"/\" {...props} role={undefined} />,\n);\n\nfunction Router(props: { children?: React.ReactNode }) {\n  const { children } = props;\n  if (typeof window === 'undefined') {\n    return <StaticRouter location=\"/\">{children}</StaticRouter>;\n  }\n\n  return <MemoryRouter>{children}</MemoryRouter>;\n}\n\nexport default function ButtonRouter() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Router>\n        <Button component={RouterLink} to=\"/\">\n          With prop forwarding\n        </Button>\n        <br />\n        <Button component={LinkBehavior}>With inlining</Button>\n      </Router>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Router"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "component"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "RouterLink"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "to"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            "          With prop forwarding"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "        <",
              [
                "span",
                "pl-ent",
                "br"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "component"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "LinkBehavior"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">With inlining</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Router"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 31,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "react",
      "react-router",
      "@mui/material/Button"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
